/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AncillaryManagerListQuery
 */
export interface AncillaryManagerListQuery {
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof AncillaryManagerListQuery
     */
    ancillaryType?: Int32IdAndLabel;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof AncillaryManagerListQuery
     */
    ancillary?: GuidIdAndLabel;
    /**
     * 
     * @type {number}
     * @memberof AncillaryManagerListQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AncillaryManagerListQuery
     */
    limit?: number | null;
}

export function AncillaryManagerListQueryFromJSON(json: any): AncillaryManagerListQuery {
    return AncillaryManagerListQueryFromJSONTyped(json, false);
}

export function AncillaryManagerListQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AncillaryManagerListQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ancillaryType': !exists(json, 'ancillaryType') ? undefined : Int32IdAndLabelFromJSON(json['ancillaryType']),
        'ancillary': !exists(json, 'ancillary') ? undefined : GuidIdAndLabelFromJSON(json['ancillary']),
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function AncillaryManagerListQueryToJSON(value?: AncillaryManagerListQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ancillaryType': Int32IdAndLabelToJSON(value.ancillaryType),
        'ancillary': GuidIdAndLabelToJSON(value.ancillary),
        'offset': value.offset,
        'limit': value.limit,
    };
}


